import dayjs from 'dayjs'
import { isAppStateReady } from 'src/state/store'
import { defer } from 'react-router-dom'
import useTimeclockStore from '../store'
import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { getDateRangeFromQueryStringOrAppStore } from '../../../../common/helpers/queryString'

export default async function loader({ request }) {
  const queryParams = getQueryStringParamsFromStringUrl(request.url)

  logger.debug(
    '[loader] About to await AppState being ready in StaffClocks loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in StaffClocks loader')

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getTimeClockins = useTimeclockStore
    .getState()
    .getTimeClockins(startDateTime, endDateTime, true, true, undefined, false)

  const getStaffMembers = useTimeclockStore
    .getState()
    .getStaffMembers(dayjs().set('seconds', 0).set('milliseconds', 0))

  const getPackages = useTimeclockStore.getState().getPackages()

  return defer({
    data: Promise.all([getTimeClockins, getStaffMembers, getPackages])
      .then(() => true)
      .catch((error) => {
        logger.error('Staff Clocks Promise.all error', error)
        return false
      }),
  })
}
